import React, { useState } from "react";
import imageP from "../../assets/cirugia g.png";
import imageD from "../../assets/derma g.png";
import imageE from "../../assets/estetica g.png";
import imageT from "../../assets/trasplante g.png";
import imageM from "../../assets/micropigmentacion.png";
import CardReasonComponent from "./cardReason";
import "./styles.css";

const ThirdQuestionComponent = ({
  modalityAndSpecialtySelected,
  responseValidationAndGetData,
}) => {
  const [dermaReasonListVisible, setDermaReasonListVisible] = useState(false);
  const [esteticaReasonListVisible, setEsteticaReasonListVisible] =
    useState(false);
  const [plasticaReasonListVisible, setPlasticaReasonListVisible] =
    useState(false);
  const [capilarReasonListVisible, setCapilarReasonListVisible] =
    useState(false);
  const [
    micropigmentacionReasonListVisible,
    setMicropigmentacionReasonListVisible,
  ] = useState(false);

  const specialityList = responseValidationAndGetData?.specialityList;

  let dermatologiaReasonList;
  let esteticaReasonList;
  let plasticaReasonList;
  let capilarReasonList;
  let micropigmentacionReasonList;

  const onClickDermatologia = () => {
    setDermaReasonListVisible(true);
    setEsteticaReasonListVisible(false);
    setPlasticaReasonListVisible(false);
    setCapilarReasonListVisible(false);
    setMicropigmentacionReasonListVisible(false);
  };

  const onClickEstetica = () => {
    setDermaReasonListVisible(false);
    setEsteticaReasonListVisible(true);
    setPlasticaReasonListVisible(false);
    setCapilarReasonListVisible(false);
    setMicropigmentacionReasonListVisible(false);
  };

  const onClickPlastica = () => {
    setDermaReasonListVisible(false);
    setEsteticaReasonListVisible(false);
    setPlasticaReasonListVisible(true);
    setCapilarReasonListVisible(false);
    setMicropigmentacionReasonListVisible(false);
  };

  const onClickCapilar = () => {
    setDermaReasonListVisible(false);
    setEsteticaReasonListVisible(false);
    setPlasticaReasonListVisible(false);
    setCapilarReasonListVisible(true);
    setMicropigmentacionReasonListVisible(false);
  };

  const onClickMicropigmentacion = () => {
    setDermaReasonListVisible(false);
    setEsteticaReasonListVisible(false);
    setPlasticaReasonListVisible(false);
    setCapilarReasonListVisible(false);
    setMicropigmentacionReasonListVisible(true);
  };

  specialityList.map((item) => {
    let { id, reasonList } = item;
    switch (id) {
      case "01":
        dermatologiaReasonList = reasonList;
        break;
      case "02":
        esteticaReasonList = reasonList;
        break;
      case "04":
        plasticaReasonList = reasonList;
        break;
      case "06":
        capilarReasonList = reasonList;
        break;
      case "07":
        micropigmentacionReasonList = reasonList;
        break;

      default:
        break;
    }
  });

  return (
    <div className="containerThirdQuestion">
      <h1 className="questionAppointment">Seleccione una especialidad</h1>
      <div className="cardsSpecialties">
        <a
          href="#CardReasonComponent"
          className="cardSpecialty"
          onClick={onClickDermatologia}
        >
          <img className="imageSpecialties" src={imageD} alt="Dermatología" />
          <div className="specialityTextContainer">
            <div className="specialityTitle">Dermatología</div>
            <div className="specialityText">
              La valoración de piel, manchas, acné, cicatrices y el ajuste de
              rutina cosmética, son consultas médicas dermatológicas y tienen
              todas un coste de 90€
            </div>
          </div>
        </a>
        <a
          href="#CardReasonComponent"
          className="cardSpecialty"
          onClick={onClickEstetica}
        >
          <img className="imageSpecialties" src={imageE} alt="Estética" />
          <div className="specialityTextContainer">
            <div className="specialityTitle">Estética</div>
            <div className="specialityText">
              Tratamientos inyectables estéticos.
            </div>
          </div>
        </a>
        <a
          href="#CardReasonComponent"
          className="cardSpecialty"
          onClick={onClickPlastica}
        >
          <img
            className="imageSpecialties"
            src={imageP}
            alt="Cirugía Plástica"
          />
          <div className="specialityTextContainer">
            <div className="specialityTitle">Cirugía Plástica</div>
            <div className="specialityText">
              Visita informativa gratuita sobre cirugía plástica
            </div>
          </div>
        </a>
        <a
          href="#CardReasonComponent"
          className="cardSpecialty"
          onClick={onClickCapilar}
        >
          <img
            className="imageSpecialties"
            src={imageT}
            alt="Trasplante capilar"
          />
          <div className="specialityTextContainer">
            <div className="specialityTitle">Trasplante capilar</div>
            <div className="specialityText">
              Visita gratuita informativa con emisión de presupuesto. No se
              valorará ni tratará la alopecia ni otras patologías capilares.
              <br />
              <br />
              Para el diagnóstico y tratamiento de caída capilar o alopecia
              selecciona cita en “Dermatología”.
            </div>
          </div>
        </a>
        <a
          href="#CardReasonComponent"
          className="cardSpecialty"
          onClick={onClickMicropigmentacion}
        >
          <img
            className="imageSpecialties"
            src={imageM}
            alt="Micropigmentación natural"
          />
          <div className="specialityTextContainer">
            <div className="specialityTitle">Micropigmentación</div>
            <div className="specialityText">
              Micropigmentación natural.
              <br />
              <br />
              Primera visita gratuita para valoración y diseño de
              micropigmentación en cejas, labios, areolas…
            </div>
          </div>
        </a>
      </div>

      <div id="CardReasonComponent">
        {(dermaReasonListVisible ||
          esteticaReasonListVisible ||
          plasticaReasonListVisible ||
          capilarReasonListVisible ||
          micropigmentacionReasonListVisible) && (
          <div>
            <CardReasonComponent
              dermaReasonListVisible={dermaReasonListVisible}
              esteticaReasonListVisible={esteticaReasonListVisible}
              plasticaReasonListVisible={plasticaReasonListVisible}
              capilarReasonListVisible={capilarReasonListVisible}
              micropigmentacionReasonListVisible={
                micropigmentacionReasonListVisible
              }
              dermatologiaReasonList={dermatologiaReasonList}
              esteticaReasonList={esteticaReasonList}
              plasticaReasonList={plasticaReasonList}
              capilarReasonList={capilarReasonList}
              micropigmentacionReasonList={micropigmentacionReasonList}
              modalityAndSpecialtySelected={modalityAndSpecialtySelected}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ThirdQuestionComponent;
